import { render, staticRenderFns } from "./sequenceCatalogPage.vue?vue&type=template&id=1373e1f4"
import script from "./sequenceCatalogPage.vue?vue&type=script&lang=ts"
export * from "./sequenceCatalogPage.vue?vue&type=script&lang=ts"
import style0 from "./sequenceCatalogPage.vue?vue&type=style&index=0&id=1373e1f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports